import React from "react";

// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const CustomerLockoutsHeader = () => {
  const headCells = [
    { id: "Lockout Triggered", numeric: false, label: "Lockout Triggered" },
    { id: "Lockout Expired", numeric: false, label: "Lockout Expired" },
    { id: "Lockout Type", numeric: false, label: "Lockout Type" },
    { id: "Lockout Cleared By", numeric: false, label: "Lockout Cleared By" },
    { id: "Action", numeric: false, label: "Action" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({label, id}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomerLockoutsHeader;
